import { MaskedLine, Reveal } from "@/components/Reveal";
import { useLanguage } from "@/lib/i18n";

const Section = ({ title, children }) => (
  <Reveal>
    <section>
      <h2 className="mb-4 font-mono text-[11px] uppercase tracking-[0.3em] text-ember-deep">{title}</h2>
      <div className="text-base font-light leading-relaxed text-smoke">{children}</div>
    </section>
  </Reveal>
);

const contactBody = (lang) => (
  <p>
    {lang === "en" ? "Phone" : "Telefon"}:{" "}
    <a href="tel:+491708105568" className="text-bone transition-colors hover:text-ember-deep" data-testid="impressum-phone-link">
      +49 170 810 55 68
    </a>
    <br />
    {lang === "en" ? "Email" : "E-Mail"}:{" "}
    <a href="mailto:mail@wimjansen.de" className="text-bone transition-colors hover:text-ember-deep" data-testid="impressum-email-link">
      mail@wimjansen.de
    </a>
  </p>
);

const DE = [
  {
    title: "Angaben gemäß § 5 DDG",
    body: <p className="text-bone">Wim Jansen Delgado<br />Gojenbergsweg 62<br />21029 Hamburg</p>,
  },
  { title: "Kontakt", body: contactBody("de") },
  {
    title: "Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV",
    body: <p>Wim Jansen Delgado<br />Gojenbergsweg 62, 21029 Hamburg</p>,
  },
  {
    title: "Haftung für Inhalte",
    body: <p>Die Inhalte dieser Website wurden mit großer Sorgfalt erstellt. Für Richtigkeit, Vollständigkeit und Aktualität wird jedoch keine Gewähr übernommen. Als Diensteanbieter bin ich für eigene Inhalte nach den allgemeinen Gesetzen verantwortlich, jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen.</p>,
  },
  {
    title: "Haftung für Links",
    body: <p>Diese Website enthält gegebenenfalls Links zu externen Websites Dritter, auf deren Inhalte ich keinen Einfluss habe. Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter verantwortlich. Zum Zeitpunkt der Verlinkung waren keine Rechtsverstöße erkennbar.</p>,
  },
  {
    title: "Urheberrecht",
    body: <p>Alle auf dieser Website gezeigten Fotografien und Texte sind urheberrechtlich geschützt. Jede Verwendung, insbesondere Vervielfältigung, Bearbeitung und Verbreitung, bedarf der vorherigen schriftlichen Zustimmung von Wim Jansen Delgado.</p>,
  },
];

const EN = [
  {
    title: "Information pursuant to § 5 DDG (German Digital Services Act)",
    body: <p className="text-bone">Wim Jansen Delgado<br />Gojenbergsweg 62<br />21029 Hamburg, Germany</p>,
  },
  { title: "Contact", body: contactBody("en") },
  {
    title: "Responsible for the content pursuant to § 18 (2) MStV",
    body: <p>Wim Jansen Delgado<br />Gojenbergsweg 62, 21029 Hamburg, Germany</p>,
  },
  {
    title: "Liability for content",
    body: <p>The contents of this website were created with great care. However, no guarantee is given for their accuracy, completeness or topicality. As a service provider I am responsible for my own content in accordance with general legislation, but I am not obliged to monitor transmitted or stored third-party information.</p>,
  },
  {
    title: "Liability for links",
    body: <p>This website may contain links to external third-party websites over whose content I have no influence. The respective provider is always responsible for the content of the linked pages. No legal violations were apparent at the time of linking.</p>,
  },
  {
    title: "Copyright",
    body: <p>All photographs and texts shown on this website are protected by copyright. Any use, in particular reproduction, editing and distribution, requires the prior written consent of Wim Jansen Delgado.</p>,
  },
];

export default function Impressum() {
  const { lang } = useLanguage();
  const sections = lang === "en" ? EN : DE;
  return (
    <div className="mx-auto max-w-7xl px-6 pb-16 pt-28 md:px-12 md:pt-36 lg:px-16" data-testid="impressum-page">
      <Reveal>
        <p className="mb-4 font-mono text-sm uppercase tracking-[0.15em] text-smoke">
          {lang === "en" ? "Legal" : "Rechtliches"}
        </p>
      </Reveal>
      <h1 className="font-serif font-light tracking-tight text-bone" data-testid="impressum-title">
        <MaskedLine delay={0.1} className="text-[clamp(2.6rem,6vw,5rem)]">
          {lang === "en" ? "Imprint" : "Impressum"}
        </MaskedLine>
      </h1>

      <div className="mt-14 grid grid-cols-12 gap-x-6 gap-y-10 md:gap-x-10">
        <div className="col-span-12 space-y-14 md:col-span-7">
          {sections.map((s) => (
            <Section key={s.title} title={s.title}>{s.body}</Section>
          ))}
        </div>
      </div>
    </div>
  );
}
